import React, { useContext, useEffect } from 'react';
import Container from '../common/components/Container/Container';
import Loading from '../common/components/Loading/Loading';
import { AuthenticationContext } from '../providers/AuthenticationContext';

import { FlowConfigContext } from '../providers/FlowConfigContext';
import AuthTokenEventPayload from '../services/events/authTokenEventPayload';
import withRouteAnalytics from '../services/analytics/withRouteAnalytics';
import { Screens } from '../services/analytics/screens';

function NoFlowScreen(): JSX.Element {
  const { getCurrentToken } = useContext(AuthenticationContext);
  const { initialized, flowSuccessful } = useContext(FlowConfigContext);

  const flowSuccessfulWithAuth = async () => {
    const token = await getCurrentToken();
    flowSuccessful(new AuthTokenEventPayload(token.success()));
  };

  useEffect(() => {
    if (!initialized) {
      return;
    }

    // Attempt to emit the success event with the token, fallback to emitting the success event with no payload
    flowSuccessfulWithAuth().catch(() => flowSuccessful());
  }, [initialized]);

  return (
    <Container>
      <Loading dataTestId="IN_PROGRESS" />
    </Container>
  );
}
export default withRouteAnalytics(NoFlowScreen, Screens.NO_FLOW);
